import {Pipe, PipeTransform} from '@angular/core';
import {UtilService} from '../util/util.service';
import {CommonDatePipe} from './common-date.pipe';

@Pipe({
  name: 'lastChange'
})
export class LastChangePipe implements PipeTransform {

  constructor(private utilService: UtilService) {
  }

  transform(value: string, args?: any): string {
    if (!this.utilService.checkIfEmpty(value)) {
      return "Last updated " + new CommonDatePipe(this.utilService).transform(value, true);
    }
    return '';
  }
}
